<template>
  <Listbox as="div" v-model="newAgent">
    <ListboxLabel class="inline-block align-middle text-sm font-medium text-gray-700 mr-2"> {{ $t('conversation.assignedTo') }}</ListboxLabel>
    <div class="mt-1 relative inline-block align-middle">
      <ListboxButton class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <span class="flex items-center" v-if="assignedAgent">
          <AgentAvatar v-bind:agent="assignedAgent" :diameter="24" classes="h-6 w-6" />
          <span class="ml-3 block truncate">{{ assignedAgent.attributes.name }}</span>
        </span>
        <span class="flex items-center" v-else>
          <span class="ml-3 block truncate">---</span>
        </span>
        <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div>
          <ListboxOptions class=" shadow-2xl absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm min-w-min overflow-x-hidden">
            <ListboxOption as="template" v-for="agent in agentsStore.collection" :key="agent.id" :value="agent" v-slot="{ active, selected }">
              <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9 min-w-min']">
                <div class="flex items-center">
                  <AgentAvatar v-bind:agent="agent" classes="h-6 w-6" diameter="24" />
                  <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                    {{ agent.attributes.name }}
                  </span>
                </div>
                <span v-if="selected" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </div>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { useAgentStore } from '@/stores/agents'
import AgentAvatar from '../../agents/AgentAvatar.vue'

import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'


export default {
  components: {
    AgentAvatar,
    //
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
  setup() {
    const agentsStore = useAgentStore();

    return {
      agentsStore,
    }
  },
  props: ['assignedAgentId'],
  created() {
    this.newAgent = this.assignedAgent;
  },
  computed: {
    assignedAgent() {
      return this.agentsStore.getById(this.assignedAgentId);
    },
  },
  watch: {
    newAgent(newAgent) {
      if (newAgent && newAgent.id !== this.assignedAgentId) {
        this.$emit('change-assigned-agent', newAgent.id);
      }
    },
    assignedAgent(currentAgent) {
      this.newAgent = currentAgent;
    },
  },
  data() {
    return {
      newAgent: undefined,
    }
  },
}
</script>
